import TabWithCounter from "ds/components/Tab/WithCounter";
import Box from "ds/components/Box";

import { PredefinedFilterType } from "../constants";
import usePredefinedFilters from "../usePredefinedFilters";
import styles from "./styles.module.css";

const TABS = [
  { id: PredefinedFilterType.AllStacks, label: "All" },
  { id: PredefinedFilterType.NeedsAttention, label: "Needs attention" },
  { id: PredefinedFilterType.Failed, label: "Failed" },
  { id: PredefinedFilterType.OnHold, label: "On hold" },
  { id: PredefinedFilterType.InProgress, label: "In progress" },
  { id: PredefinedFilterType.Finished, label: "Finished" },
];

type StackFiltersLayoutTabNavigationProps = {
  counts?: Record<PredefinedFilterType, number>;
};

const StackFiltersLayoutTabNavigation = ({ counts }: StackFiltersLayoutTabNavigationProps) => {
  const { predefinedFilterTab, setPredefinedFilter } = usePredefinedFilters();

  return (
    <Box
      className={styles.tabNavigation}
      align="center"
      justify="start"
      gap="medium"
      fullWidth
      role="tablist"
    >
      {TABS.map(({ id, label }) => (
        <TabWithCounter
          key={id}
          id={id}
          label={label}
          onClick={setPredefinedFilter}
          isActive={predefinedFilterTab === id}
          count={counts?.[id]}
        />
      ))}
    </Box>
  );
};

export default StackFiltersLayoutTabNavigation;
